import { domainConstants } from './../_constants';
import { domainServices } from './../_services';
import { alertActions } from './';

export const domainActions = {
  insertDomain,
  updateDomain,
  removeDomain,
  getDomainsByToken,
  getInfoDomainByGero,
  defineSelectedDomain
}

function insertDomain(name, address){
  return dispatch => {
    dispatch(dAlert(domainConstants.REGISTER_DOMAIN_REQUEST, {name, address}));

    return domainServices.insertDomainService(name, address)
      .then(data => {
          return dispatch(dAlert(domainConstants.REGISTER_DOMAIN_SUCCESS, data));
        },
        error => {
          dispatch(alertActions.failure(error));
          return dispatch(dAlert(domainConstants.REGISTER_DOMAIN_FAILURE, error));
        }
      )
  }
}

function removeDomain(uuid) {
  return dispatch => {
    dispatch(dAlert(domainConstants.DOMAIN_REMOVAL_REQUEST, uuid));

    return domainServices.removeRegisteredDomain(uuid)
      .then(data => {
        return dispatch(dAlert(domainConstants.DOMAIN_REMOVAL_SUCCESS, data));
      }, error => {
        return dispatch(dAlert(domainConstants.DOMAIN_REMOVAL_FAILURE, error));
      })
  }
}

function updateDomain(name, address) {
  return dispatch => {
    dispatch(dAlert(domainConstants.DOMAIN_UPDATE_REQUEST, {name: name, address: address}));

    return domainServices.updateRegisteredDomain(name, address)
      .then(data => {
        return dispatch(dAlert(domainConstants.DOMAIN_UPDATE_SUCCESS, data));
      }, error => {
        return dispatch(dAlert(domainConstants.DOMAIN_UPDATE_FAILURE, error));
      })
  }
}

function getDomainsByToken(){
  return dispatch => {
    dispatch(dAlert(domainConstants.VERIFY_DOMAIN_REQUEST, null));
    
    return domainServices.getDomainsByCompanyUuid()
      .then( data => {
          if ( [data.data].length === 0 && !sessionStorage.getItem('cellit_domains') ) return;
        
          sessionStorage.setItem('cellit_domains', JSON.stringify(data.data));
          return dispatch(dAlert(domainConstants.VERIFY_DOMAIN_SUCCESS, data));
        },
        error => {
          dispatch(alertActions.failure(error));
          return dispatch(dAlert(domainConstants.VERIFY_DOMAIN_FAILURE, error));
        }
      )
  }
}

function getInfoDomainByGero(uuid){
  return dispatch => {
    dispatch(dAlert(domainConstants.VERIFY_SCRIPT_GERO_REQUEST, {uuid}));

    return domainServices.verifyDomainByGero(uuid)
      .then(data => {
        dispatch(alertActions.success(data));
        return dispatch(dAlert(domainConstants.VERIFY_SCRIPT_GERO_SUCCESS, data));
        },
        error => {
          dispatch(alertActions.failure(error));
          return dispatch(dAlert(domainConstants.VERIFY_SCRIPT_GERO_FAILURE, error));
        }
      )
  }
}

function defineSelectedDomain(domain) {
  return dispatch => {
    dispatch(alertActions.success(domain));
    return dispatch({
      type: domainConstants.DOMAIN_CHANGE_SUCCESS,
      domain
    });
  }
}

const dAlert = (constant, data) => {
  return { type: constant, data }
}